'use es6';

import { reduce } from '../../lib/async';
import { configure as duration } from '../pipelineStage/dealStageDuration';
const mutators = [duration];
export default (config => {
  return reduce(mutators, (mutated, mutator) => mutator(mutated), config);
});